// extracted by mini-css-extract-plugin
module.exports = {"DatePickerNote":"OrderSummary_DatePickerNote__21FGK","SummaryBox":"OrderSummary_SummaryBox__1r7nJ"};